export interface VideoItem {
  id: string;
  title: string;
  thumbnail: string;
  duration: string;
  category: string;
  views: string;
  rating: string;
  quality: string;
  description: string;
  publishDate: string;
  tags: string[];
  source: string;
}

export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { slug: "dianying", name: "电影", icon: "ri-film-line", description: "最新热门电影，高清在线观看" },
  { slug: "dianshiju", name: "电视剧", icon: "ri-tv-line", description: "热门电视剧全集免费看" },
  { slug: "zongyi", name: "综艺", icon: "ri-emotion-laugh-line", description: "热门综艺节目在线观看" },
  { slug: "dongman", name: "动漫", icon: "ri-rocket-line", description: "日漫国漫精彩不断" },
  { slug: "duanshipin", name: "短视频", icon: "ri-smartphone-line", description: "精彩短视频每日更新" },
  { slug: "jilupian", name: "纪录片", icon: "ri-earth-line", description: "高清纪录片探索世界" },
  { slug: "tiyu", name: "体育", icon: "ri-basketball-line", description: "体育赛事精彩回放" },
  { slug: "yinyue", name: "音乐", icon: "ri-music-line", description: "MV与音乐现场" },
];

export const videos: Record<string, VideoItem[]> = {
  dianying: [
    {
      id: "mv-001",
      title: "流浪地球3：星辰大海",
      thumbnail: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20scene%20with%20astronauts%20in%20space%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20epic%20scale%2C%20film%20poster%20style%2C%20deep%20space%20background%20with%20stars%20and%20nebula&width=800&height=450&seq=mv-001&orientation=landscape",
      duration: "02:28:15",
      category: "dianying",
      views: "1280万",
      rating: "9.2",
      quality: "4K",
      description: "《流浪地球3：星辰大海》是流浪地球系列的第三部作品，延续了前作的宏大叙事，人类在宇宙中的旅程进入全新篇章。影片讲述地球在经历木星危机和太阳氦闪之后，人类文明在星际旅行中面临的新的生存挑战与希望。",
      publishDate: "2026-07-20",
      tags: ["科幻", "冒险", "灾难", "国产大片"],
      source: "香蕉视频",
    },
    {
      id: "mv-002",
      title: "封神第二部：战火西岐",
      thumbnail: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20fantasy%20battle%20scene%20with%20ancient%20warriors%2C%20dramatic%20sky%2C%20cinematic%20lighting%2C%20film%20poster%20style%2C%20grand%20scale&width=800&height=450&seq=mv-002&orientation=landscape",
      duration: "02:15:42",
      category: "dianying",
      views: "980万",
      rating: "8.8",
      quality: "4K",
      description: "封神第二部：战火西岐延续第一部的故事，讲述姜子牙率领西岐大军与殷商展开最终对决。宏大的战争场面，精美的特效制作，再现了中国神话的壮丽史诗。",
      publishDate: "2026-06-15",
      tags: ["神话", "奇幻", "战争", "国产大片"],
      source: "红桃视频",
    },
    {
      id: "mv-003",
      title: "速度与激情12：终局之路",
      thumbnail: "https://readdy.ai/api/search-image?query=High-speed%20racing%20cars%20in%20city%20at%20night%2C%20dramatic%20action%20scene%2C%20cinematic%20lighting%2C%20film%20poster%20style%2C%20explosive%20atmosphere&width=800&height=450&seq=mv-003&orientation=landscape",
      duration: "02:08:33",
      category: "dianying",
      views: "1560万",
      rating: "8.5",
      quality: "1080P",
      description: "速度与激情12：终局之路是速度与激情系列的最新力作，家族再次集结面对最终挑战。极速狂飙、惊险动作、感人情感，一部不容错过的动作大片。",
      publishDate: "2026-07-01",
      tags: ["动作", "赛车", "犯罪", "好莱坞"],
      source: "91视频",
    },
    {
      id: "mv-004",
      title: "哪吒之魔童闹海2",
      thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20animation%20style%20mythological%20character%20with%20fire%20and%20water%20elements%2C%20dramatic%20composition%2C%20vibrant%20colors%2C%20film%20poster%20style%2C%20epic%20fantasy&width=800&height=450&seq=mv-004&orientation=landscape",
      duration: "01:52:08",
      category: "dianying",
      views: "2100万",
      rating: "9.5",
      quality: "4K",
      description: "哪吒之魔童闹海2是国产动画电影的又一力作，延续前作的精良制作，讲述哪吒在东海龙宫的全新冒险。精美的画面和感人的故事，再次刷新国产动画纪录。",
      publishDate: "2026-05-28",
      tags: ["动画", "神话", "奇幻", "国产动画"],
      source: "蜜桃视频",
    },
    {
      id: "mv-005",
      title: "孤注一掷2：暗网追踪",
      thumbnail: "https://readdy.ai/api/search-image?query=Dark%20cyberpunk%20thriller%20scene%20with%20digital%20code%20and%20mysterious%20figure%2C%20cinematic%20lighting%2C%20film%20poster%20style%2C%20tense%20atmosphere&width=800&height=450&seq=mv-005&orientation=landscape",
      duration: "01:58:45",
      category: "dianying",
      views: "890万",
      rating: "8.7",
      quality: "1080P",
      description: "孤注一掷2：暗网追踪延续前作的反诈主题，深入暗网世界，讲述网络犯罪调查团队与国际诈骗集团的惊险对决。扣人心弦的剧情，揭示网络犯罪的惊人内幕。",
      publishDate: "2026-06-20",
      tags: ["犯罪", "悬疑", "剧情", "国产"],
      source: "香蕉视频",
    },
    {
      id: "mv-006",
      title: "变形金刚：超能勇士崛起2",
      thumbnail: "https://readdy.ai/api/search-image?query=Giant%20robot%20transforming%20in%20epic%20battle%20scene%2C%20cinematic%20lighting%2C%20explosive%20background%2C%20film%20poster%20style%2C%20sci-fi%20atmosphere&width=800&height=450&seq=mv-006&orientation=landscape",
      duration: "02:12:30",
      category: "dianying",
      views: "1100万",
      rating: "8.3",
      quality: "4K",
      description: "变形金刚：超能勇士崛起2将汽车人与巨无霸的联盟推向新的高度，地球面临前所未有的威胁。震撼的视觉特效，经典的变形金刚动作场面。",
      publishDate: "2026-07-10",
      tags: ["科幻", "动作", "机甲", "好莱坞"],
      source: "红桃视频",
    },
  ],
  dianshiju: [
    {
      id: "tv-001",
      title: "繁花似锦 第二季",
      thumbnail: "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20period%20drama%20scene%20with%20traditional%20architecture%2C%20warm%20lighting%2C%20nostalgic%20atmosphere%2C%20TV%20series%20poster%20style%2C%20soft%20cinematic%20look&width=800&height=450&seq=tv-001&orientation=landscape",
      duration: "45分钟/集",
      category: "dianshiju",
      views: "890万",
      rating: "9.0",
      quality: "4K",
      description: "繁花似锦第二季延续第一季的故事线，讲述了上海滩在新时代背景下的家族兴衰与人物命运。精致的画面、细腻的表演，再现了一段波澜壮阔的时代画卷。",
      publishDate: "2026-07-15",
      tags: ["年代剧", "家族", "上海", "国产剧"],
      source: "91视频",
    },
    {
      id: "tv-002",
      title: "长安十二时辰2",
      thumbnail: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20city%20at%20night%20with%20lanterns%2C%20mysterious%20atmosphere%2C%20TV%20series%20poster%20style%2C%20historical%20drama%2C%20cinematic%20lighting&width=800&height=450&seq=tv-002&orientation=landscape",
      duration: "50分钟/集",
      category: "dianshiju",
      views: "750万",
      rating: "9.3",
      quality: "4K",
      description: "长安十二时辰2将故事背景转移到洛阳，一场更大的阴谋正在酝酿。精美的服化道和考究的古代场景，再现盛唐气象。",
      publishDate: "2026-06-10",
      tags: ["古装", "悬疑", "历史", "国产剧"],
      source: "蜜桃视频",
    },
    {
      id: "tv-003",
      title: "狂飙：暗夜行动",
      thumbnail: "https://readdy.ai/api/search-image?query=Crime%20drama%20scene%20with%20police%20and%20suspects%20in%20modern%20Chinese%20city%2C%20tense%20atmosphere%2C%20TV%20series%20poster%20style%2C%20dramatic%20lighting&width=800&height=450&seq=tv-003&orientation=landscape",
      duration: "42分钟/集",
      category: "dianshiju",
      views: "1850万",
      rating: "9.1",
      quality: "1080P",
      description: "狂飙：暗夜行动是狂飙系列的全新力作，讲述新一代警察在扫黑除恶斗争中的故事。紧凑的剧情，真实的案件还原，展现了正义与邪恶的较量。",
      publishDate: "2026-07-05",
      tags: ["犯罪", "剧情", "警匪", "国产剧"],
      source: "香蕉视频",
    },
    {
      id: "tv-004",
      title: "三体：黑暗森林",
      thumbnail: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20TV%20series%20scene%20with%20cosmic%20background%2C%20mysterious%20alien%20technology%2C%20cinematic%20lighting%2C%20TV%20poster%20style%2C%20deep%20space&width=800&height=450&seq=tv-004&orientation=landscape",
      duration: "55分钟/集",
      category: "dianshiju",
      views: "2200万",
      rating: "9.4",
      quality: "4K",
      description: "三体：黑暗森林根据刘慈欣同名小说改编，讲述了面壁计划与破壁人的精彩对决。宏大的宇宙观、精妙的科幻设定，引发观众对宇宙文明的深思。",
      publishDate: "2026-05-20",
      tags: ["科幻", "宇宙", "改编", "国产剧"],
      source: "红桃视频",
    },
  ],
  zongyi: [
    {
      id: "zy-001",
      title: "奔跑吧·第十二季",
      thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20outdoor%20games%20with%20celebrities%2C%20colorful%20and%20energetic%2C%20TV%20show%20poster%20style%2C%20fun%20atmosphere%2C%20bright%20lighting&width=800&height=450&seq=zy-001&orientation=landscape",
      duration: "90分钟/期",
      category: "zongyi",
      views: "3200万",
      rating: "8.6",
      quality: "1080P",
      description: "奔跑吧第十二季全新出发，全新的游戏挑战和嘉宾阵容，带来更多欢笑与感动。户外竞技与团队合作的完美结合。",
      publishDate: "2026-07-12",
      tags: ["户外", "竞技", "明星", "搞笑"],
      source: "91视频",
    },
    {
      id: "zy-002",
      title: "向往的生活·山海季",
      thumbnail: "https://readdy.ai/api/search-image?query=Peaceful%20countryside%20Chinese%20lifestyle%20show%20with%20farmhouse%20and%20garden%2C%20warm%20lighting%2C%20TV%20poster%20style%2C%20relaxing%20atmosphere&width=800&height=450&seq=zy-002&orientation=landscape",
      duration: "85分钟/期",
      category: "zongyi",
      views: "1800万",
      rating: "8.9",
      quality: "1080P",
      description: "向往的生活·山海季来到美丽的海边小镇，嘉宾们体验渔村生活，享受最质朴的田园时光。美食、美景与温暖的友情交织。",
      publishDate: "2026-06-25",
      tags: ["生活", "美食", "慢综艺", "治愈"],
      source: "蜜桃视频",
    },
  ],
  dongman: [
    {
      id: "dm-001",
      title: "斗破苍穹·年番",
      thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20animation%20fantasy%20martial%20arts%20scene%20with%20magical%20energy%2C%20dramatic%20composition%2C%20vibrant%20colors%2C%20anime%20poster%20style%2C%20epic%20scale&width=800&height=450&seq=dm-001&orientation=landscape",
      duration: "22分钟/集",
      category: "dongman",
      views: "4500万",
      rating: "9.3",
      quality: "4K",
      description: "斗破苍穹年番持续热播，萧炎的冒险旅程愈加精彩。顶级的3D动画制作，酣畅淋漓的战斗场面，国产动画的标杆之作。",
      publishDate: "2026-07-01",
      tags: ["玄幻", "战斗", "3D动画", "国产"],
      source: "香蕉视频",
    },
    {
      id: "dm-002",
      title: "完美世界·战王之殇",
      thumbnail: "https://readdy.ai/api/search-image?query=Chinese%203D%20animation%20fantasy%20battle%20with%20celestial%20warriors%2C%20epic%20scale%2C%20anime%20poster%20style%2C%20magical%20effects%2C%20golden%20color%20scheme&width=800&height=450&seq=dm-002&orientation=landscape",
      duration: "20分钟/集",
      category: "dongman",
      views: "3800万",
      rating: "9.1",
      quality: "4K",
      description: "完美世界·战王之殇篇将故事推向高潮，石昊的成长之路充满了挑战与感动。史诗级的战斗场面，精美的画面呈现。",
      publishDate: "2026-06-18",
      tags: ["玄幻", "修仙", "3D动画", "国产"],
      source: "红桃视频",
    },
  ],
  duanshipin: [
    {
      id: "sp-001",
      title: "世界奇观：极光之舞",
      thumbnail: "https://readdy.ai/api/search-image?query=Breathtaking%20northern%20lights%20aurora%20in%20Arctic%20sky%2C%20vibrant%20green%20and%20purple%2C%20cinematic%20quality%2C%20nature%20documentary%20style%2C%20wide%20angle&width=800&height=450&seq=sp-001&orientation=landscape",
      duration: "03:28",
      category: "duanshipin",
      views: "560万",
      rating: "9.6",
      quality: "4K",
      description: "摄影师在北极圈内耗时三个月拍摄的极光延时作品，捕捉了自然界最壮观的光影舞蹈。每一帧都可作为壁纸的精美画面。",
      publishDate: "2026-07-22",
      tags: ["自然", "极光", "延时摄影", "风景"],
      source: "91视频",
    },
    {
      id: "sp-002",
      title: "街头美食：重庆小面传奇",
      thumbnail: "https://readdy.ai/api/search-image?query=Delicious%20Chinese%20street%20food%20spicy%20noodles%20in%20Chongqing%2C%20steaming%20hot%2C%20food%20photography%20style%2C%20vibrant%20colors%2C%20appetizing%20close-up&width=800&height=450&seq=sp-002&orientation=landscape",
      duration: "05:12",
      category: "duanshipin",
      views: "890万",
      rating: "9.2",
      quality: "1080P",
      description: "走进重庆街头，探访最地道的小面馆。从选材到熬制辣椒油，从擀面到出锅，全程记录一碗正宗重庆小面的诞生。",
      publishDate: "2026-07-18",
      tags: ["美食", "重庆", "街头", "小吃"],
      source: "蜜桃视频",
    },
  ],
  jilupian: [
    {
      id: "doc-001",
      title: "地球脉动：深海奇境",
      thumbnail: "https://readdy.ai/api/search-image?query=Deep%20ocean%20documentary%20scene%20with%20bioluminescent%20creatures%2C%20mysterious%20underwater%20world%2C%20nature%20documentary%20style%2C%20cinematic%20lighting%2C%20blue%20ambient&width=800&height=450&seq=doc-001&orientation=landscape",
      duration: "52:18",
      category: "jilupian",
      views: "680万",
      rating: "9.8",
      quality: "4K",
      description: "BBC级别的深海纪录片，首次深入马里亚纳海沟万米深处，记录了前所未见的深海生物和生态系统。每一帧都是对生命奇迹的致敬。",
      publishDate: "2026-07-08",
      tags: ["自然", "海洋", "BBC", "科普"],
      source: "香蕉视频",
    },
  ],
  tiyu: [
    {
      id: "sp-003",
      title: "NBA总决赛2026 精彩集锦",
      thumbnail: "https://readdy.ai/api/search-image?query=NBA%20basketball%20finals%20dramatic%20dunk%20moment%2C%20packed%20arena%2C%20sports%20photography%20style%2C%20high%20energy%2C%20cinematic%20action&width=800&height=450&seq=sp-003&orientation=landscape",
      duration: "15:42",
      category: "tiyu",
      views: "2100万",
      rating: "9.4",
      quality: "4K",
      description: "2026 NBA总决赛精彩集锦，收录了每场比赛的关键时刻和精彩进球。从绝杀到扣篮，每一秒都让人热血沸腾。",
      publishDate: "2026-07-25",
      tags: ["NBA", "篮球", "集锦", "体育"],
      source: "红桃视频",
    },
  ],
  yinyue: [
    {
      id: "mu-001",
      title: "华语音乐盛典2026 现场",
      thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20music%20awards%20ceremony%20live%20concert%20with%20stage%20lights%2C%20grand%20performance%2C%20music%20show%20poster%20style%2C%20colorful%20lighting&width=800&height=450&seq=mu-001&orientation=landscape",
      duration: "02:05:30",
      category: "yinyue",
      views: "1200万",
      rating: "8.8",
      quality: "4K",
      description: "2026华语音乐盛典完整版，汇集了年度最受欢迎的歌手的精彩表演。顶级的舞美设计和音响效果，一场视听盛宴。",
      publishDate: "2026-07-20",
      tags: ["音乐", "演唱会", "华语", "现场"],
      source: "91视频",
    },
  ],
};

export const featuredVideos: VideoItem[] = [
  videos.dianying[3],
  videos.dianshiju[3],
  videos.dongman[1],
  videos.dianying[0],
];

export const trendingList: VideoItem[] = [
  videos.dongman[0],
  videos.zongyi[0],
  videos.dianshiju[3],
  videos.tiyu[0],
  videos.dianying[3],
  videos.dianshiju[2],
  videos.music[0],
  videos.dianying[1],
  videos.dianying[2],
  videos.zongyi[1],
];

export function getVideosByCategory(slug: string): VideoItem[] {
  return videos[slug] || [];
}

export function getVideoById(id: string): VideoItem | undefined {
  for (const categoryVideos of Object.values(videos)) {
    const found = categoryVideos.find((v) => v.id === id);
    if (found) return found;
  }
  return undefined;
}

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((c) => c.slug === slug);
}